module.exports = __webpack_public_path__ + "img/jobs3.7f52ab95.png";